import React, { ReactElement } from 'react';
import { API_BASE_URL } from '@synergy/config';
import { FormattedMessage, useIntl } from 'react-intl';
import { PoolBanner } from '@synergy/components-next';
import { PoolButton } from '@synergy/components';
import { Stack } from '@mui/material';
import urlJoin from 'url-join';

import { ExportInvoice } from '../models/export-invoice';

export interface ExportInvoicesModalNotificationsProps {
    latestExport?: ExportInvoice;
}

export const ExportInvoicesModalNotifications = (props: ExportInvoicesModalNotificationsProps): ReactElement | null => {
    const { latestExport } = props;
    const intl = useIntl();

    const handleDownload = (): void => {
        if (latestExport?.path) {
            window.open(urlJoin(API_BASE_URL, latestExport.path), '_self');
        }
    };

    if (!latestExport?.startedDate && !latestExport?.finishedDate) {
        return null;
    }

    if (latestExport?.hasErrors) {
        return (
            <PoolBanner variant="outlined" severity="error">
                <FormattedMessage id="app.export.invoicesModal.errorBanner" />
            </PoolBanner>
        );
    }

    if (latestExport?.startedDate && !latestExport?.finishedDate) {
        return (
            <PoolBanner variant="outlined">
                <FormattedMessage id="app.export.invoicesModal.exportRunning" />
            </PoolBanner>
        );
    }

    return (
        <PoolBanner
            severity="success"
            variant="outlined"
            action={
                <PoolButton variant="text" onClick={handleDownload} sx={{ mr: 1 }}>
                    <FormattedMessage id="app.export.invoicesModal.download" />
                </PoolButton>
            }
        >
            <Stack direction="row" justifyContent="space-between">
                <FormattedMessage
                    id="app.export.invoicesModal.exportSuccess"
                    values={{
                        date: latestExport?.finishedDate
                            ? intl.formatDate(latestExport.finishedDate, {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                              })
                            : '',
                        startedBy: latestExport?.startedBy,
                    }}
                />
            </Stack>
        </PoolBanner>
    );
};
